import { observer } from 'mobx-react';
import React from 'react';

import { type Taggable } from 'stores/Taggable';

import BaseTagsManager from '../../TagsManager/TagsManager';

export interface TagsManagerProps {
  parentDocument: Taggable;
  title?: string;
}

// TODO: This file begins a chain of imports that are sole importers.
//  So for example, this could be collapsed into the file imported as
//  BaseTagsManager. But it extends beyond that too; CardWrapper is
//  only used by BaseTagsManager

function TagsManager({ parentDocument, title }: TagsManagerProps) {
  return (
    <BaseTagsManager
      activeTags={parentDocument.data.tags}
      addTag={parentDocument.addTag}
      removeTag={parentDocument.removeTag}
      title={title}
    />
  );
}

export default observer(TagsManager);
